import { AssessmentHealthRow } from '@/services/assessmentsAPI';

export function formatDuration(seconds: number | null): string {
  if (seconds == null) return '—';
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function progressLabel(row: AssessmentHealthRow): string {
  return `${row.questions_transcribed}/${row.questions_total} transcribed · ${row.questions_scored}/${row.questions_total} scored`;
}
